<template>
  <div>
    <div v-if="showShoppingCart()">
      <div class="row fixed-bottom d-print-none">
        <div class="col">
          <button class="open-card-btn fixed-bottom custom-margin-bottom  rounded-circle m-1"
                  data-toggle="modal"
                  data-target="#shopping-cart"
                  @click="reloadBasket">
            <img :src="setShoppingCartIcon()" alt="">
            <m-shopping-cart-counter1 class="position-absolute"/>
          </button>
        </div>
      </div>


      <div class="" dir="ltr">
        <div class="modal right fade" id="shopping-cart" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">

              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                    aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <h5 class="px-3  text-center" v-t="'un_authenticated_side_shopping_cart.title'"></h5>
                <div class="container-fluid p-0">

                  <div class="row p-0 m-0 w-100" v-if="IsAuthenticated">
                    <div v-for="food in foods" :key="food.id" class="pb-0 my-1 col-12">
                      <m-c17 :food="food.product" :sub-product="food.sub_product" :basket="basket"/>
                    </div>
                  </div>
                  <div class="row p-0 m-0 w-100" v-else>
                    <div v-for="food in productList" :key="food.id" class="p-2 pb-0 col-12">
                      <template v-for="(sub_product,index) in subProducts(food)" :key="index">
                        <m-c17 v-if="findHashProductOnLocalStorage(sub_product) != undefined" :food="food"
                               :sub-product="productHashToLocalStorageItem(findHashProductOnLocalStorage(sub_product)).sub_product_id"
                               :basket="basket"/>
                      </template>
                    </div>
                  </div>

                  <div
                      v-if="this.basket.items !== undefined && this.basket.items.length > 0 && IsAuthenticated"
                      class="text-center col-12 my-2">
                    <router-link data-dismiss="modal" :to="{ name: 'ShoppingCart' }" class=" text-center">
                      <button class="pay-button rounded-pill m-2 p-3"
                              v-t="'un_authenticated_side_shopping_cart.authenticated.submit_button'"
                      >
                      </button>
                    </router-link>
                  </div>
                  <div v-if="!IsAuthenticated"
                       class="text-center my-2 col-12">

                    <m-un-authenticate-summary1 :products="productList"/>

                    <router-link data-dismiss="modal" :to="{ name: 'Login' }"
                                 v-if="findAttributeOnSiteInfo('order_on_unauthenticated_shopping_cart')[0] == 0"
                                 class="text-center ">
                      <button class="pay-button rounded-pill m-2 p-3"
                              v-t="'un_authenticated_side_shopping_cart.unAuthenticated.pay_without_authenticate_off'">
                      </button>
                    </router-link>
                    <router-link data-dismiss="modal" :to="{ name: 'UnAuthenticatedShoppingCart' }" v-else
                                 class="text-center ">
                      <button class="pay-button rounded-pill m-2 p-3"
                              v-t="'un_authenticated_side_shopping_cart.unAuthenticated.pay_without_authenticate_on'">

                      </button>
                    </router-link>


                  </div>

                </div>
              </div>

            </div><!-- modal-content -->
          </div><!-- modal-dialog -->
        </div><!-- modal -->
      </div>
    </div>


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {subProducts} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findHashProductOnLocalStorage} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import store from "@/store";
import mC17 from "../Product/Card/C17";
import mUnAuthenticateSummary1 from "../UnAuthenticatedShoppingCart/UnAuthenticateSummary1";
import mShoppingCartCounter1 from "../ShoppingCart/ShoppingCartCounter/ShoppingCartCounter1";
import {productHashToLocalStorageItem} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions'

export default {
  name: "Sc2",
  components: {mC17, mUnAuthenticateSummary1, mShoppingCartCounter1},
  props: {
    haveItem: {
      default: 'data:image/svg+xml;base64,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'
    },
    empty: {
      default: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUyLjk0NiA1Mi45NDYiIHN0eWxlPSJmaWxsOndoaXRlIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwYXRoIGQ9Ik0yNi40NzQsOS41ODhDMTMuMzE4LDkuNTg4LDAsMTIuMDQzLDAsMTYuNzM2djAuMTQ4YzAsMTQuNTk4LDExLjg3NiwyNi40NzQsMjYuNDc0LDI2LjQ3NA0KCWMxNC41OTcsMCwyNi40NzMtMTEuODc2LDI2LjQ3My0yNi40NzR2LTAuMTQ4QzUyLjk0NiwxMi4wNDMsMzkuNjI5LDkuNTg4LDI2LjQ3NCw5LjU4OHogTTI2LjQ3NCwxMS41ODgNCgljMTQuOTM5LDAsMjQuNDczLDMuMDQ5LDI0LjQ3Myw1LjE0OHMtOS41MzMsNS4xNDgtMjQuNDczLDUuMTQ4Yy0xNC45MzgsMC0yNC40NzMtMy4wNS0yNC40NzQtNS4xNDgNCglDMiwxNC42MzcsMTEuNTM0LDExLjU4OCwyNi40NzQsMTEuNTg4eiIvPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo='
    }
  },
  data() {
    return {
      shoppingCartCount: 0,
    }
  },
  computed: {
    ...mapGetters({
      foods: "ShoppingCart/getUserOrderUnpaidItems",
      basket: "ShoppingCart/getSidebarBasketData",
      IsAuthenticated: "User/isAuthenticated",
      productList: "ShoppingCart/getProductList"
    }),
    setSidebarSize() {
      if (window.screen.width > 500) {
        return '500px';
      }
      return '320px';
    }
  },
  methods: {
    subProducts,
    productHashToLocalStorageItem,
    findHashProductOnLocalStorage,
    setShoppingCartIcon() {
      if ((this.basket.items !== undefined && this.basket.items.length > 0) || this.shoppingCartCount > 0) {
        return this.haveItem;
      }
      return this.empty;
    },
    async getUnAuthBasketItems() {
      if (localStorage.getItem('products') !== null) {

        let productsJson = JSON.parse(localStorage.getItem('products'))
        let form = new FormData();
        let counter = 0;

        Object.keys(productsJson).forEach(function (key) {
          form.append(`product[${counter}][id]`, productsJson[key]['id'])
          if (productsJson[key]['sub_product_id'] > 0) {
            form.append(`product[${counter}][sub_product]`, productsJson[key]['sub_product_id'])
          }
          counter += 1;
        })

        let user_id = this.$store.getters['User/getUserId']
        store.dispatch("ShoppingCart/addItemWithoutState", {user_id, form}).then(res => {
          const shoppingCart = res.data.data;
          const order_id = shoppingCart.id;
          const items = shoppingCart.items;


          // find local storage item in shopping cart items
          items.forEach(item => {
            Object.keys(productsJson).forEach(function (key) {
              let product = productsJson[key];
              if (product['sub_product_id'] == item.sub_product && product['id'] == item.product.id) {

                let form = {
                  order_id: order_id,
                  order_product_id: item.id,
                  quantity: product['quantity'],
                  user_id: user_id,
                }

                store.dispatch("ShoppingCart/changeQuantityWithoutState", form)

              }
            })
          })


        })

        this.$store.dispatch('ShoppingCart/userOrderUnpaid')
        localStorage.removeItem('products')

      }
    },
    async reloadBasket() {
      let productsLink = [];
      let productsJson = JSON.parse(localStorage.getItem('products'))
      if (productsJson !== null) {
        Object.keys(productsJson).forEach(function (key) {
          productsLink.push(productsJson[key]['product'])
        })
        await this.$store.dispatch("ShoppingCart/getProductList", productsLink)
      }
    },
    countItemsOnUnAuthenticatedShoppingCart() {
      const localProducts = localStorage.products;
      this.shoppingCartCount = localProducts != undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
      this.$forceUpdate();
    },
    showShoppingCart() {
      if (process.env.NODE_ENV != 'development') {
        return ['UnAuthenticatedShoppingCart', 'ShoppingCart'].indexOf(this.$route.name) == -1
      }
      return true
    },
  },
  async mounted() {
    if (this.showShoppingCart()) {
      if (this.$store.getters['User/isAuthenticated']) {
        await this.$store.dispatch("ShoppingCart/userOrderUnpaid")
        await this.getUnAuthBasketItems(this.$store.getters["ShoppingCart/getSidebarBasketData"])
      } else {
        let productsLink = [];
        let productsJson = JSON.parse(localStorage.getItem('products'))
        if (productsJson !== null) {
          Object.keys(productsJson).forEach(function (key) {
            productsLink.push(productsJson[key]['product'])
          })
          await this.$store.dispatch("ShoppingCart/getProductList", productsLink)
        }


        this.countItemsOnUnAuthenticatedShoppingCart();


      }
    }
  }
}
</script>

<style scoped>

.open-card-btn {
  background: var(--secondary);
  border: none;
  outline: none;
}

.open-card-btn:focus {
  border: none;
  outline: none;
}

.fixed-bottom {
  width: 70px;
  height: 70px;
}

.custom-margin-bottom {
  bottom: 70px !important;
}

.pay-button {
  bottom: 30px;
  border: none !important;
}

@media screen and (max-width: 480px) {
  .open-card-btn {
    bottom: 90px;
  }
}


.modal.left .modal-dialog,
.modal.right .modal-dialog {
  position: fixed;
  margin: auto;
  max-width: 450px;
  height: 100%;
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

.modal.left .modal-content,
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.left .modal-body,
.modal.right .modal-body {
  padding: 15px 15px 80px;
}

:deep(.shopping-cart-counter-1) {
  font-size: 15px;
}
</style>
